import React, { useState, useContext, useEffect, useRef } from "react";
// import Cookies from "js-cookie";
import {
  Button,
  Typography,
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import ReactQuill from "react-quill";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { errorDialogOpen } from "../../redux/dialogs/dialogActions";
import {
  ArrowForward,
  DeleteForever,
  DeleteOutlineOutlined,
  CancelOutlined,
  Close,
} from "@mui/icons-material";
import { AddApplicationContext } from "../../context/AddApplicationContext";
import TestComponent from "../../components/TestComponent";
import ErrorModal from "../../components/ErrorModal";
import ErrorText from "../../components/ErrorText";
import { basePath } from "../../utility";
import ProcessProgress from "../../components/ProcessProgress";
import LoaderModal from "../../components/LoaderModal";
import useFetch from "../../hooks/useFetch";

export default function ProgramDetails() {
  const [country, setCountry] = useState("");
  // const [openCategories, setOpenCategories] = useState(false);
  // const [contributorType, setContributorType] = useState("author");
  // const [contributorFirstName, setContributorFirstName] = useState("");
  // const [contributorLastName, setContributorLastName] = useState("");
  // const [publisherName, setPublisherName] = useState("");

  // const [nationalityList, setNationalityList] = useState(null);
  // const [ethnicityList, setEthnicityList] = useState(null);
  // const [religionList, setReligionList] = useState(null);
  // const [programList, setProgramList] = useState(null);
  const [programsPerLevel, setProgramsPerLevel] = useState(null);
  const [programLevel, setProgramLevel] = useState(null);
  // const [periodList, setPeriodList] = useState(null);

  const [passportPhoto, setPassportPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [feedback, setFeedback] = useState(null);

  const [openLoader, setOpenLoader] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState(null);
  const [onSuccessButtonLable, setOnSuccessButtonLable] = useState(null);

  const [onErrorButtonLable, setOnErrorButtonLable] = useState(null);
  const url = basePath.url;

  const [nationalityList, pendingNationalityList, errorNationalityList] =
    useFetch(`${url}demographics/nationality`);
  const [ethnicityList, pendingEthnicityList, errorEthnicityList] = useFetch(
    `${url}demographics/ethnicity`
  );
  const [religionList, pendingReligionList, errorReligionList] = useFetch(
    `${url}demographics/religion`
  );
  const [countyList, pendingCountyList, errorCountyList] = useFetch(
    `${url}demographics/counties`
  );
  const [programList, pendingProgramList, errorProgramList] = useFetch(
    `${url}courses`
  );

  const [programLevelList, pendingProgramLevelList, errorProgramLevelList] =
    useFetch(`${url}courses/level`);
  const [periodList, pendingPeriodList, errorPeriodLevelList] = useFetch(
    `${url}sem-period`
  );

  const {
    currentStep,
    setStep,
    applicationId,
    setApplicationId,
    stepDetails,
    setStepDetails,
    stepsCompleteStatus,
    setStepsCompletedStatus,
  } = useContext(AddApplicationContext);

  const dispatch = useDispatch();
  const logger = useSelector((state) => {
    return state.logger;
  });
  const errDialog = useSelector((state) => {
    return state.dialogReducer;
  });

  const courses = useSelector((state) => {
    return state.coursesReducer.courses;
  });

  const semPeriods = useSelector((state) => {
    return state.semPeriodReducer.semPeriods;
  });

  const quilref = useRef("");

  const initialValues = {
    firstName:
      stepDetails.programDetails && stepDetails.programDetails.firstName
        ? stepDetails.programDetails.firstName
        : "",
    lastName:
      stepDetails.programDetails && stepDetails.programDetails.lastName
        ? stepDetails.programDetails.lastName
        : "",
    surname:
      stepDetails.programDetails && stepDetails.programDetails.surname
        ? stepDetails.programDetails.surname
        : "",
    salutation:
      stepDetails.programDetails && stepDetails.programDetails.salutation
        ? stepDetails.programDetails.salutation
        : "",
    dateOfBirth:
      stepDetails.programDetails && stepDetails.programDetails.dateOfBirth
        ? stepDetails.programDetails.dateOfBirth
        : "",
    nationality:
      stepDetails.programDetails && stepDetails.programDetails.nationality
        ? stepDetails.programDetails.nationality
        : "",
    identification:
      stepDetails.programDetails && stepDetails.programDetails.identification
        ? stepDetails.programDetails.identification
        : "",
    scannedIdentification:
      stepDetails.programDetails &&
      stepDetails.programDetails.scannedIdentification
        ? stepDetails.programDetails.scannedIdentification
        : "",
    gender:
      stepDetails.programDetails && stepDetails.programDetails.gender
        ? stepDetails.programDetails.gender
        : "",
    religion:
      stepDetails.programDetails && stepDetails.programDetails.religion
        ? stepDetails.programDetails.religion
        : "",
    ethnicity:
      stepDetails.programDetails && stepDetails.programDetails.ethnicity
        ? stepDetails.programDetails.ethnicity
        : "",
    phoneNumber:
      stepDetails.programDetails && stepDetails.programDetails.phoneNumber
        ? stepDetails.programDetails.phoneNumber
        : "",
    county:
      stepDetails.programDetails && stepDetails.programDetails.county
        ? stepDetails.programDetails.county
        : "",

    disabilityStatus:
      stepDetails.programDetails && stepDetails.programDetails.disabilityStatus
        ? stepDetails.programDetails.disabilityStatus
        : "",
    passportImage:
      stepDetails.programDetails && stepDetails.programDetails.passportImage
        ? stepDetails.programDetails.passportImage
        : "",
    // programLevel:
    //   stepDetails.programDetails && stepDetails.programDetails.programLevel
    //     ? stepDetails.programDetails.programLevel
    //     : "",
    programName:
      stepDetails.programDetails && stepDetails.programDetails.programName
        ? stepDetails.programDetails.programName
        : "",
    intakePeriod:
      stepDetails.programDetails && stepDetails.programDetails.intakePeriod
        ? stepDetails.programDetails.intakePeriod
        : "",
    modeOfStudy:
      stepDetails.programDetails && stepDetails.programDetails.modeOfStudy
        ? stepDetails.programDetails.modeOfStudy
        : "",
  };

  const validationSchema = Yup.object({
    salutation: Yup.string().required("Please select salutation"),
    dateOfBirth: Yup.date().required("Please enter date of birth"),
    nationality: Yup.string().required("Please select nationality"),
    firstName: Yup.string().required("Please enter your Firs tName"),
    lastName: Yup.string().required("Please your Last Name"),
    identification: Yup.string().required(
      "Please enter ID Number or Passport or Birth Certificate"
    ),
    scannedIdentification: Yup.string().required(
      "Please select scanned ID Number or Passport or Birth Certificate to upload "
    ),
    gender: Yup.string().required("Please select gender"),
    religion: Yup.string().required("Please select religion"),
    ethnicity: Yup.string().when("nationality", {
      is: (val) => parseInt(val) == 116,
      then: () => Yup.string().required("Please Select Ethnicity"),
    }),
    // .required("Please select ethnicity"),
    phoneNumber: Yup.string().required("Please select phone number"),
    county: Yup.string().when("nationality", {
      is: (val) => parseInt(val) == 116,
      then: () => Yup.string().required("Please select county"),
    }),
    disabilityStatus: Yup.string().required(
      "Please confirm your disability status"
    ),
    passportImage: Yup.string().required("Please select passport photo"),
    // programLevel: Yup.string().required("Please select program level"),
    programName: Yup.string().required("Please select program name"),
    intakePeriod: Yup.string().required("Please select intake period"),
    modeOfStudy: Yup.string().required("Please select Mode of Study"),
  });

  const onSuccessCallback = () => {
    setOpenLoader(false);
    setStep((val) => {
      return val + 1;
    });
  };

  const onErrorCallback = () => {
    setOpenLoader(false);
  };

  const onSubmitDetails = async (values, onSubmitProps) => {
    setError(null);
    setLoading(true);
    setFeedback(null);
    setOpenLoader(true);
    setLoaderMessage("Adding Program Details");

    values.target = "applications";
    values.type = stepDetails.programDetails?.applicationId ? "update" : "add";
    values.user_id = logger.user.userId;

    // console.log(values);
    // return;

    const formData = new FormData();

    formData.append("target", values.target);

    formData.append("scannedIdentification", values.scannedIdentification);
    formData.append("passportImage", values.passportImage);

    formData.append("type", values.type);
    formData.append("user_id", values.user_id);
    formData.append("salutation", values.salutation);
    formData.append("firstName", values.firstName);
    formData.append("lastName", values.lastName);
    formData.append("surname", values.surname);
    formData.append("gender", values.gender);
    formData.append("dob", values.dob);
    formData.append("nationality", values.nationality);
    formData.append("identification", values.identification);
    formData.append("religion", values.religion);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("disabilityStatus", values.disabilityStatus);
    formData.append("programName", values.programName);
    formData.append("intakePeriod", values.intakePeriod);
    formData.append("modeOfStudy", values.modeOfStudy);
    formData.append("county", values.county);
    formData.append("ethnicity", values.ethnicity);
    formData.append(
      "applicationId",
      stepDetails.programDetails?.applicationId
        ? stepDetails.programDetails.applicationId
        : null
    );

    let application_id_get = null;
    try {
      const addProgram = await axios.post(
        `${url}application/add-program`,
        formData
      );
      // console.log(addProgram);
      if (addProgram.data.message === "error") {
        let err_data = addProgram.data.data;
        setError(
          // err_data === "duplicate"
          //   ? "Book with the same  number  exists"
          //   : addProgram.data.data
          "Error Adding Program Details"
        );
        setLoading(false);
        setFeedback(null);
        onSubmitProps.setSubmitting(false);
        // onSubmitProps.resetForm();
      } else {
        if (!addProgram.data.data) {
          setError(true);
          setOnErrorButtonLable("Ok");
          values.type === "add"
            ? setLoaderMessage("Error Adding Program Details! Please try again")
            : setLoaderMessage(
                "Error Updating Program Details! Please try again"
              );
          setLoading(false);
        } else {
          const stepData = { ...stepDetails };
          values.applicationId = addProgram.data.data.applicationId;
          stepData.programApplicationNumber =
            addProgram.data.data.applicationNumber;
          stepData.programDetails = values;
          setStepDetails(stepData);
          setError(null);
          setLoading(false);
          setFeedback("Program Details Added Successfully");
          onSubmitProps.setSubmitting(false);
          onSubmitProps.resetForm();
          setOnSuccessButtonLable("Ok");
          // setStep1Completed(true);
          values.type === "add"
            ? setLoaderMessage("Program Details added successfully")
            : setLoaderMessage("Program Details updated successfully");
          setLoading(false);
          setError(null);
        }
      }
    } catch (error) {
      setLoaderMessage(`Error Adding Program Details ${error.message}`);
      setError("Error Adding Application Program Details");
      setOnErrorButtonLable("Ok");
      // addProgram.data.action === "add"
      //   ? setLoaderMessage("Error Adding Program Details! Please try again")
      //   : setLoaderMessage("Error Updating Program Details! Please try again");
      setLoading(false);
      setFeedback(null);
      onSubmitProps.setSubmitting(false);
      //onSubmitProps.resetForm();
    }
  };

  // const book_categories = useSelector((state) => {
  //   return state.categoriesReducer;
  // });

  useEffect(() => {
    if (programLevelList) {
      let level = programLevelList.filter((level) => {
        return level.id == programLevel;
      });

      let currentLevelAmount = level[0].application_amount;

      const step_details = { ...stepDetails };
      step_details.programApplicationFee = currentLevelAmount;

      setStepDetails(step_details);
    }
  }, [programLevel]);

  useEffect(() => {
    setProgramsPerLevel(null);

    if (programList) {
      setProgramsPerLevel(
        programList.filter((program, index) => {
          return program.course_category_id == programLevel;
        })
      );
    }
  }, [programLevel]);

  return (
    <>
      <ErrorModal />
      <LoaderModal
        loaderMessage={loaderMessage}
        openLoader={openLoader}
        setOpenLoader={setOpenLoader}
        loading={loading}
        error={error}
        onSuccessButtonLable={onSuccessButtonLable}
        onSuccessCallback={onSuccessCallback}
        onErrorButtonLable={onErrorButtonLable}
        onErrorCallback={onErrorCallback}
      />

      <div className="addBookWrapper" style={{ height: "100%" }}>
        <Formik
          // enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={onSubmitDetails}
          validationSchema={validationSchema}
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            isValid,
            isSubmitting,
            setFieldValue,
            setValues,
          }) => (
            <Form>
              <div className="addBookContainer">
                <div className="addBookCaption">
                  <Typography variant="subtitle2">
                    <span className="header2">Personal Data</span>
                  </Typography>
                </div>
                <div className="addBookDetails">
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Salutation:</label>
                      <Field
                        as="select"
                        name="salutation"
                        id="salutation"
                        // style={{ width: "90%" }}
                      >
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value=""
                        >
                          Select Salutation
                        </option>
                        <option value="Mr.">Mr.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Miss.">Miss.</option>
                        <option value="Dr.">Dr.</option>
                      </Field>
                      <ErrorMessage name="salutation" component={ErrorText} />
                    </div>

                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>First Name:</label>
                      <Field
                        type="text"
                        name="firstName"
                        id="firstName"
                        // style={{ width: "90%" }}
                      />
                      <ErrorMessage name="firstName" component={ErrorText} />
                    </div>

                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>last Name</label>
                      <Field type="text" name="lastName" id="lastName" />

                      <ErrorMessage name="lastName" component={ErrorText} />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Surname:</label>
                      <Field
                        type="text"
                        name="surname"
                        id="surname"
                        // style={{ width: "90%" }}
                      />
                      <ErrorMessage name="surname" component={ErrorText} />
                    </div>
                  </div>
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Gender:</label>
                      <Field
                        as="select"
                        name="gender"
                        id="gender"
                        // style={{ width: "90%" }}
                      >
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value=""
                        >
                          Select Gender
                        </option>
                        <option value="Male.">Male</option>
                        <option value="Female.">Female</option>
                        <option value="Intersex.">Intersex</option>
                      </Field>
                      <ErrorMessage name="gender" component={ErrorText} />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Date of Birth:</label>
                      <Field
                        type="date"
                        name="dateOfBirth"
                        id="dateOfBirth"
                        // style={{ width: "90%" }}
                      />
                      <ErrorMessage name="dateOfBirth" component={ErrorText} />
                    </div>

                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Nationality</label>
                      <select
                        value={country}
                        name="country"
                        id="country"
                        onChange={(e) => {
                          setCountry(e.target.value);
                          // setCountry(
                          //   nationalityList.find((item) => {
                          //     return item.id == e.target.value;
                          //   }).name
                          // );
                          setFieldValue("nationality", e.target.value);
                          if (e.target.value != 116) {
                            setFieldValue("ethnicity", "");
                            setFieldValue("county", "");
                          }
                        }}

                        // style={{ width: "90%" }}
                      >
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value=""
                        >
                          Select Nationality
                        </option>
                        {nationalityList &&
                          nationalityList.map((country, index) => {
                            return (
                              <option
                                style={{
                                  fontSize: 12,
                                  fontFamily: "sans-serif",
                                }}
                                key={index}
                                value={country.id}
                              >
                                {country.name}
                              </option>
                            );
                          })}
                      </select>

                      <ErrorMessage name="nationality" component={ErrorText} />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Passport/National ID No/ Birth Cert:</label>
                      <Field
                        type="text"
                        name="identification"
                        id="identification"
                        // style={{ width: "90%" }}
                      />
                      <ErrorMessage
                        name="identification"
                        component={ErrorText}
                      />
                    </div>
                  </div>
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>religion:</label>
                      <Field
                        as="select"
                        name="religion"
                        id="religion"
                        // style={{ width: "90%" }}
                      >
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value=""
                        >
                          Select Religion
                        </option>
                        {religionList &&
                          religionList.map((religion, index) => {
                            return (
                              <option
                                style={{
                                  fontSize: 12,
                                  fontFamily: "sans-serif",
                                }}
                                key={index}
                                value={religion.id}
                              >
                                {religion.name}
                              </option>
                            );
                          })}
                      </Field>
                      <ErrorMessage name="religion" component={ErrorText} />
                    </div>

                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Phone Number</label>
                      <Field
                        type="text"
                        name={"phoneNumber"}
                        id="phoneNumber"
                        // style={{ width: "90%" }}
                      />

                      <ErrorMessage name="phoneNumber" component={ErrorText} />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Person With Disability?:</label>
                      <Field
                        as="select"
                        name="disabilityStatus"
                        id="disabilityStatus"
                      >
                        <option value="">Select</option>
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                      </Field>

                      <ErrorMessage
                        name="disabilityStatus"
                        component={ErrorText}
                      />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    ></div>
                  </div>
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div className="formControl" style={{ flex: 1 }}>
                      <label>
                        Passport Size Photo{" "}
                        <span style={{ color: "grey" }}>(jpeg/jpg/png)</span>
                      </label>
                      <input
                        type="file"
                        name="passportPhoto"
                        onChange={(e) => {
                          setPassportPhoto(e.target.files[0]);

                          setFieldValue("passportImage", e.target.files[0]);
                          setPhotoPreview(
                            URL.createObjectURL(e.target.files[0])
                          );
                        }}
                        style={{ width: "auto" }}
                      />
                      <ErrorMessage
                        name="passportImage"
                        component={ErrorText}
                      />
                    </div>
                    <div className="formControl" style={{ flex: 1 }}>
                      <label>Scanned Passport/ID/Birth Cert</label>
                      <input
                        type="file"
                        onChange={(e) => {
                          setFieldValue(
                            "scannedIdentification",
                            e.target.files[0]
                          );
                        }}
                      />
                      <ErrorMessage
                        name={"scannedIdentification"}
                        component={ErrorText}
                      />
                    </div>

                    <div className="formControl" style={{ flex: 1 }}>
                      {country && country == 116 ? (
                        <>
                          <label>Ethnicity:</label>
                          <Field
                            as="select"
                            name="ethnicity"
                            id="ethnicity"
                            // style={{ width: "90%" }}
                          >
                            <option value="">Select Ethnicity</option>
                            {ethnicityList &&
                              ethnicityList.map((ethnic, index) => {
                                return (
                                  <option key={index} value={ethnic.id}>
                                    {ethnic.name}
                                  </option>
                                );
                              })}
                          </Field>
                          <ErrorMessage
                            name="ethnicity"
                            component={ErrorText}
                          />
                        </>
                      ) : null}
                    </div>
                    <div className="formControl" style={{ flex: 1 }}>
                      {country && country == 116 ? (
                        <>
                          <label>County:</label>
                          <Field
                            as="select"
                            name="county"
                            id="county"
                            // style={{ width: "90%" }}
                          >
                            <option value="">Select County</option>
                            {countyList &&
                              countyList.map((county, index) => {
                                return (
                                  <option key={index} value={county.id}>
                                    {county.name}
                                  </option>
                                );
                              })}
                          </Field>
                          <ErrorMessage name="county" component={ErrorText} />
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div
                  className="fullWidthWrapper"
                  style={{
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    className="formControl"
                    style={{ flex: 1, padding: 10, boxSizing: "border-box" }}
                  >
                    {photoPreview && (
                      <img
                        src={photoPreview}
                        width={200}
                        height={200}
                        style={{
                          objectFit: "scale-down",
                          backgroundColor: "#fcfcfc",
                          border: "0.5px solid solid",
                          borderColor: "#ccc",
                          borderWidth: 0.5,
                          borderStyle: "dashed",
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="addBookContainer">
                <div className="addBookCaption">
                  <Typography variant="subtitle2">
                    <span className="header2">Program Details</span>
                  </Typography>
                </div>
                <div className="addBookDetails">
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Program Level:</label>
                      <select
                        name="programLevel"
                        id="programLevel"
                        value={programLevel}
                        onChange={(e) => {
                          setProgramLevel(e.target.value);
                        }}
                        // style={{ width: "90%" }}
                      >
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value=""
                        >
                          Select Program Level
                        </option>
                        {programLevelList &&
                          programLevelList.map((level, index) => {
                            return (
                              <option key={index} value={level.id}>
                                {level.name}
                              </option>
                            );
                          })}
                      </select>
                      {/* <ErrorMessage name="programLevel" component={ErrorText} /> */}
                    </div>

                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Programme Name</label>
                      <Field
                        as="select"
                        name="programName"
                        id="programName"
                        // style={{ width: "90%" }}
                      >
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value=""
                        >
                          Select Programme Name
                        </option>
                        {programsPerLevel && programLevel
                          ? programsPerLevel.map((program, index) => {
                              return (
                                <option
                                  style={{
                                    fontSize: 12,
                                    fontFamily: "sans-serif",
                                  }}
                                  key={index}
                                  value={program.courseID}
                                >
                                  {program.courseName}
                                </option>
                              );
                            })
                          : null}
                      </Field>
                      <ErrorMessage name="programName" component={ErrorText} />
                    </div>

                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Intake Period</label>
                      <Field
                        as="select"
                        name="intakePeriod"
                        id="intakePeriod"
                        // style={{ width: "90%" }}
                      >
                        <option value="">Select Intake Period</option>
                        {periodList &&
                          periodList
                            .filter((period) => {
                              return (
                                new Date(period.endDate).getTime() >
                                new Date().getTime()
                              );
                            })
                            .map((period, index) => {
                              return (
                                <option key={index} value={period.periodID}>
                                  {period.periodName}
                                </option>
                              );
                            })}
                      </Field>
                      <ErrorMessage name="intakePeriod" component={ErrorText} />
                    </div>

                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Mode of Study:</label>
                      <Field
                        as="select"
                        name="modeOfStudy"
                        id="modeOfStudy"
                        // style={{ width: "90%" }}
                      >
                        <option value="">Select Mode of Study</option>
                        <option value="Full Time">Full Time</option>
                        <option value="Part Time">Part Time (Online)</option>
                      </Field>
                      <ErrorMessage name="modeOfStudy" component={ErrorText} />
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  margin: 10,
                  paddingTop: 10,
                }}
              >
                <button
                  type="submit"
                  className="btn-primary"
                  // onClick={() => {
                  //   setStep((val) => {
                  //     return val + 1;
                  //   });
                  // }}
                  // disabled={!isValid || isSubmitting}
                >
                  Save and Continue
                </button>
                <div>
                  {/* {stepDetails.programApplicationFee &&
                    stepDetails.programApplicationFee} */}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}
